/*******************************************************************************
 * Dependency Imports
 ******************************************************************************/
// auth::api
import * as Api from './api'
// lodash - https://lodash.com/
import _ from 'lodash'

/*******************************************************************************
 * Services
 ******************************************************************************/

/*******************************************************************************
 * Configuration
 ******************************************************************************/

/*******************************************************************************
 * Transformer prototypes
 ******************************************************************************/

/*******************************************************************************
 * Private methods
 ******************************************************************************/

/**
 * general success
 *
 * @param {obj} data
 * @return {obj} le data
 */
const _onSuccess = data => {

    if( _.get( data, 'data.data' ) ) {
        return _.get( data, 'data.data' )
    }

    return data

}

/**
 * general fail
 *
 * @param {obj} error from a server
 * @return {obj} the error
 */
const _onFailed = error => new Promise(( resolve, reject ) => {

    let error_obj = error.hasOwnProperty( 'response' ) ? error.response : error

    let return_error = {
        ...error_obj.data,
        status: error_obj.status
    }

    reject( return_error )

})

/*******************************************************************************
 * Public methods
 ******************************************************************************/

export const show = async check_id =>
    Api.show(check_id)
        .then(_onSuccess)
        .catch(_onFailed)

export const update = async (check_id, data) =>
    Api.update(check_id, data)
        .then(_onSuccess)
        .catch(_onFailed)

export const deleteCheck = async check_id =>
    Api.deleteCheck(check_id)
        .then(_onSuccess)
        .catch(_onFailed)

export const listForAsset = async (asset_id, params) =>
    Api.listForAsset(asset_id, params)
        .then(_onSuccess)
        .catch(_onFailed)

export const createForAsset = async (asset_id, data) =>
    Api.createForAsset(asset_id, data)
        .then(_onSuccess)
        .catch(_onFailed)